﻿//==========================================================================================================
// Copyright (C) Nore Technology AB. All Rights Reserved.
//==========================================================================================================

//-------------------------------------------------------------------------------------
// Imports
//-------------------------------------------------------------------------------------

import { createUseStyles } from "react-jss";
import type { SoPNLConsilioTheme } from "~jrad/Styling/SoPNLConsilioTheme";

//-------------------------------------------------------------------------------------
// Styling
//-------------------------------------------------------------------------------------

export const useStyles = createUseStyles((theme: SoPNLConsilioTheme) => ({
    form: {
        marginTop: "20px",
    },
    submitButton: {
        width: "fit-content",
        marginLeft: "8px",
    },
    page: {
        width: "800px",
        textAlign: "left",
        margin: "0 auto",
        padding: "0 50px",
    },
    pageHeader: {
        textAlign: "left",
        fontSize: "40px !important",
        marginBottom: "20px !important",
    },
}));
